<template>
    <v-app>
      <Drawer current_item="menu_customer_package"></Drawer>
      
      <v-main class="ml-6 mr-6">
        <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
            >
                <v-card-title> {{ $t('customer_package_title') }}</v-card-title>
                <v-divider></v-divider>
                <v-data-table
                    :headers="headers"
                    :items-per-page="10"
                    :items="items"
                >
                    <template v-slot:top >
                        <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <DlgCustomerPackage :currCustomer="currCustomer" ref="dlgCustomerPackage" @onCloseDialog="onCloseDialog"></DlgCustomerPackage>
                        </v-toolbar>
                    </template>
                    <template  v-slot:[`item.action`]="{ item }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
      </v-main>
      <v-snackbar
            v-model="snackbar"
            timeout="2000"
     >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import config from '@/../config.js'
import DlgCustomerPackage from './DlgCustomerPackage'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
  name: 'CustomerPackage',
  computed: {
      currCustomer() {
          if (!this.items) return [];
          var result = this.items.reduce((unique, o) => {
            if(!unique.some(obj => obj.customer_name === o.customer_name)) {
            unique.push(o);
            }
            return unique;
          },[]);
          return result;
      },
        headers() {
            return [
                {text: this.$t('customer_name'), value: 'customer_name', width: '30%'},
                {text: this.$t('package_name'), value: 'package_name', width: '30%'},
                {text: this.$t('customer_package_start_date'), value: 'start_package_date', width: '15%'},
                {text: this.$t('customer_package_end_date'), value: 'end_package_date', width: '15%'},
                {text: 'Actions', value: 'action', sortable: false}
            ]
        }
  },
  components: {
      Drawer,
      DlgCustomerPackage
  },
  data: () => ({
      items: [],
      editedIndex: -1,
      snackbar: false,
      message: ''
  }),
  methods: {
      loadCustomerPackage() {
        var que = this.$store.commit('addLoading')
        axios.get(
            config.api.url.manage.customerpackage.list,
            { headers: Staff.getTokenHeader()}
        ).then(rs => {
            this.$store.commit('finishLoading',que)
            this.items = [];
            this.items = rs.data;
        })
        .catch(error => {
            this.$store.commit('finishLoading',que)
            this.$router.push({name:'Error',params:error}) 
        });
      },
      editItem(item) {
          this.editedIndex = this.items.indexOf(item);
          this.$refs.dlgCustomerPackage.show(Object.assign({}, item));
      },
      deleteItem(item) {
        var que = this.$store.commit('addLoading')
        axios.get(
            config.api.url.manage.customerpackage.delete_customer_package + item.customer_package_id,
            { headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.editedIndex = this.items.indexOf(item);
            this.items.splice(this.editedIndex, 1);
            this.editedIndex = -1;
        })
      },
      onCloseDialog(isSuccess) {
          if (isSuccess == true) {
              this.loadCustomerPackage();
              this.message = this.$t('save_success');
              this.snackbar = true;
          }
          
          this.editedIndex = -1;
      }
  },
  mounted() {
      this.loadCustomerPackage();
  }
}
</script>